import CycleDropdown from './cycle_dropdown'
import { useParams, useNavigate } from 'react-router-dom'

const AirlineCycleDropdowns = () => {
  const { airlineID, cycleID } = useParams()
  const navigate = useNavigate()

  const setCycle = (id) => navigate(buildPreservedRoute({ airlineID, cycleID: id }))

  const buildPreservedRoute = ({ airlineID, cycleID, newAirlineID, newCycleID }) => {
    const rest = window.location.pathname.split(/cycles\/\d+/)?.[1] || ''
    const paths = rest.split('/').filter(Boolean)

    // if no cycle provided, send user to "select a cycle" screen
    if (!cycleID && !newCycleID) {
      return `/airlines/${newAirlineID || airlineID}`
    }
    // Use newAirlineID/newCycleID if provided, otherwise fall back to current
    let newRoute = `/airlines/${newAirlineID || airlineID}/cycles/${newCycleID || cycleID}`
    if (paths[0] && isNaN(paths[0])) {
      newRoute += `/${paths[0]}`
      if (paths[1] && isNaN(paths[1])) {
        newRoute += `/${paths[1]}`
      }
    }
    return newRoute
  }

  if (!airlineID) return null

  return <CycleDropdown airlineID={parseInt(airlineID)} cycleID={parseInt(cycleID)} setCycle={setCycle} />
}

export default AirlineCycleDropdowns
